// Shared note-box colours (info / warn / err / gray) for the consent detail surfaces.
const NOTE_COLORS = {
  info: { light: ['#e0f2fe', '#0c4a6e', '#7dd3fc'], dark: ['#0c4a6e', '#bae6fd', '#0369a1'] },
  warn: { light: ['#fef3c7', '#92400e', '#f59e0b'], dark: ['#78350f', '#fde68a', '#b45309'] },
  err: { light: ['#fee2e2', '#991b1b', '#f87171'], dark: ['#7f1d1d', '#fca5a5', '#b91c1c'] },
  gray: { light: ['#f3f4f6', '#374151', '#d1d5db'], dark: ['#1f2937', '#e5e7eb', '#4b5563'] },
};

export function noteStyle(kind, isDark) {
  const c = NOTE_COLORS[kind][isDark ? 'dark' : 'light'];
  return {
    background: c[0], color: c[1], border: `1px solid ${c[2]}`, borderRadius: 8,
    padding: '10px 12px', fontSize: 13, lineHeight: 1.5, marginTop: 12,
  };
}
